import React, { useRef, useEffect, useState, use } from "react";
import { useSelector } from "react-redux";
import "./style/video_chat_style.css";
import { useParams, useSearchParams } from "react-router-dom";
import DailyVideoConference from "./components/video_chat_component";
import VideoCallSocketServiceImpl from "../../../data/service/impl/video_call_socket_service_impl";


const VideoChatPage = () => {
    const socket = new VideoCallSocketServiceImpl();

    const { chatChannelId } = useParams();
    const [searchParams] = useSearchParams();

    const socketOldid = searchParams.get('_usid');
    useEffect(() => {

        try {

            socket.connect({ oldSocket: socketOldid });
            socket.emit('user_landed_to_video_call_page', { oldSocketID: socketOldid });
        } catch (e) {
            console.log(e);
        }
    }, []);
    const onUserLeave = () => {

        socket.emit('user_leave_on_video_call_page', { chatChannelId });
    }
    const onMeetingJoined = () => {
    }
    return (
        <div className="video-chat-containerw-screen h-screen">
            {/* <iframe
                className="video-chat-iframe"
                src={`https://tavus.daily.co/${chatChannelId}`}
                allow="camera; microphone; display-capture; fullscreen; clipboard-read; clipboard-write; autoplay"
                sandbox="allow-same-origin allow-scripts allow-popups allow-forms allow-downloads allow-modals allow-popups-to-escape-sandbox allow-top-navigation"
                referrerPolicy="no-referrer"
            /> */}
            <DailyVideoConference roomUrl={`https://tavus.daily.co/${chatChannelId}`} onUserLeave={onUserLeave} onMeetingJoined={onMeetingJoined} />
        </div>
    );
};

export default VideoChatPage;
